import React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container'

import logo from '../../images/Weblogo.png'
import menubk from '../../images/menubk.png'
import dashboardBtn from '../../images/dashboardBtn.png'
import headerimg from '../../images/mooncropedimg.png'


const useStyles = makeStyles((theme) => ({
  logo: {
      maxWidth: 220
  },
  dashboardBtn: {
    maxWidth: 200
  },
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'unset',
  },
  links: {
    color: '#fff',
    padding: '0px 12px',
    fontWeight: 700,
    textTransform: 'uppercase',
    '&:hover': {
      color: "#f4f4f4",
      TextDecoder: 'none'
   },
  }
}));

const Menu = () => {
  const classes = useStyles();
  
  return (
    <div className={classes.root} style={{overflowX:'hidden'}}>
       <img src={headerimg} className="img-fluid mr-2" style={{maxWidth: '93px',
    zIndex: '0',
    position: 'absolute',
    // left: '92%',
    right:'-8px',
    top: '0%',}} />
           
      <div>

        <Typography variant="h6" noWrap className="pl-2 text-light">
          <Link to="/" className={classes.links}>
            <img src={logo} alt="logo" className={classes.logo + " img-fluid"} />
          </Link>
        </Typography>
      </div>
      <div style={{zIndex: '1'}}>
        <a href="/#features" className={classes.links}>FEATURES</a>
        <a href="https://github.com/interfinetwork/smart-contract-audits/blob/main/FantomMoon_AuditReport_InterFi.pdf" target="_blank" className={classes.links}>Audit</a>
        <a href="/#roadmap" className={classes.links}>ROADMAP</a>
        <a href="/#tokenomics" className={classes.links}>TOKENOMICS</a>
        <a href="/#faq" className={classes.links}>FAQ'S</a>
        <a href="https://fantom-moon.medium.com/" target="_blank" className={classes.links}>WHITEPAPER</a>
        <a href="/locker" className={classes.links + ' px-3 py-3 mr-3'} style={{backgroundColor: '#ffa83e', boxShadow: '0px 0px 10px #6c6c6c'}}>Locker</a>
        <a href="/dashboard" className={classes.links + ' px-3 py-3'} style={{backgroundColor: '#ffa83e', boxShadow: '0px 0px 10px #6c6c6c'}}>Dashboard</a>
        
        {/* <a href="/dashboard" className={classes.links} style={{border: '1px solid #ffa83e',padding: '10px 10px',
    backgroundColor: '#ffa83e'}}>DASHBOARD</a> */}
       

       
      </div>
     
    </div>
  );
}


export default Menu;
